import React from "react";

function PartnersInfo() {
  return (
    <div className="container">
      <div
        className="row"
        style={{ justifyContent: "normal", textAlign: "justify" }}
      >
        <div>
          <h1 className="fs-2" style={{ color: "#000080" }}>
            Corporates
          </h1>
          <p>
            IT FutureTech provides corporate training in developing technologies
            that are changing our economy. Our customized learning approach
            drives learner engagement and the industry’s highest completion
            rates.
          </p>
          <p>
            In today's business environment, the need for responsible business
            practices is more critical. We believe that corporate responsibility
            and sustainability can deliver added value to our clients,
            employees, partners and the communities in which we live and
            operate. We are committed to making a difference in the lives of the
            underprivileged and those who are the need. We take pride in
            integrating Corporate Social Responsibility in our thoughts and
            actions.
          </p>
        </div>
        <div className="mt-2 border-bottom">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            We believe in:
          </h1>
          <ul>
            <li>Business Ethics, Values and Principles.</li>
            <li>Accountability and Transparency.</li>
            <li>Environmental concerns.</li>
            <li>Human Rights.</li>
            <li>Workers Rights and welfare.</li>
            <li>Market relations.</li>
            <li>Sustainability.</li>
            <li>Corporate governance.</li>
          </ul>
        </div>
        <div className="mt-3">
          <h1 className="fs-2" style={{ color: "#000080" }}>
            Human Resources (HR)
          </h1>
          <p>
            At IT FutureTech, our Human Resources team plays a pivotal role in
            shaping a people-first culture that empowers individuals to grow,
            innovate, and succeed. We are committed to creating a dynamic work
            environment where collaboration, respect, and continuous learning
            are the foundation of everything we do.
          </p>
          <p>
            We understand that our people are our greatest strength. Our HR
            initiatives are designed to foster talent, drive engagement, and
            support career development at every stage. From onboarding to
            leadership training, we focus on nurturing potential and ensuring
            our team members thrive both professionally and personally.
          </p>
          <p>
            We believe in fair, inclusive, and transparent HR practices that
            align with our company values and support the well-being of our
            workforce.
          </p>
        </div>
        <div className="mt-2">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            We focus on:
          </h1>
          <ul>
            <li>Talent Acquisition and Workforce Planning.</li>
            <li>Employee Engagement and Satisfaction.</li>
            <li>Diversity, Equity, and Inclusion.</li>
            <li>Learning and Development Programs.</li>
            <li>Performance Management and Feedback Systems.</li>
            <li>Creating a Safe and Positive Work Culture.</li>
          </ul>
          <p>
            We take pride in fostering a workplace where every voice is heard,
            every contribution is valued, and every employee is given the tools
            to succeed.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PartnersInfo;
